import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { GET } from '../consts/Methods';
import { SET_LOADER } from '../redux/Loader';
import { FETCH_CHANNEL_ACTIVATION, FETCH_CHANNEL_ACTIVATION_FAIL,
         FETCH_CHANNEL_ACTIVATION_SUCCESS } from '../redux/ChannelActivations';

function* FetchChannelActivationFlow({ payload, }) {
  try {
    const endpoint = `${apiRoot}/channel_activation`;
    yield put(SET_LOADER({ value: true, }));
    const params = { channel_uniq_name: payload, };
    const response = yield call(apiCall, { method: GET, endpoint, params, });
    yield put(FETCH_CHANNEL_ACTIVATION_SUCCESS(response));
  } catch (error) {
    yield put(FETCH_CHANNEL_ACTIVATION_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* FetchChannelActivation() {
  yield takeLatest(FETCH_CHANNEL_ACTIVATION, FetchChannelActivationFlow);
}
